import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  toggleMenuContainer: {
    order: 0
  },
  toggleMenu: {
    display: 'block',
    backgroundColor: '#fff',
    height: 28,
    width: 28,
    cursor: 'pointer',
    marginLeft: 20
  },
  fillStyleMenuVisible: {
    fill: '#adadad'
  },
  fillStyleMenuNotVisible: {
    fill: '#999999'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Toggle/styles.js